<div class="policy-start-date">
  <!-- Texto ajustado al diseño -->
  <span class="policy-start-date__label">El seguro de tu moto inicial el</span>
  <!-- Usando la signal como una función y el pipe 'date' para formatear -->
  @if (startDate()) {
  <span class="policy-start-date__value">{{ startDate() | date: 'dd/MM/yyyy' }}</span>
  }
</div>